export interface Certification {
  id: string;
  name: string;
  description: string;
  code: string;
  numberOfDevs: number;
}
